import { render, staticRenderFns } from "./BrandSearch.vue?vue&type=template&id=962528c0&"
import script from "./BrandSearch.vue?vue&type=script&lang=js&"
export * from "./BrandSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports